// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

function modal(isShown) {
  return Cn.fromList({
              hd: "absolute top-0 left-0 right-0 bottom-0 w-full items-center justify-center",
              tl: {
                hd: isShown ? "flex" : "hidden",
                tl: /* [] */0
              }
            });
}

function wrapper(isShown) {
  return Cn.fromList({
              hd: "relative animate-fadeScaleIn duration-200 z-30 w-106 min-h-50 shadow-panel bg-white rounded-md",
              tl: {
                hd: isShown ? "block" : "hidden",
                tl: /* [] */0
              }
            });
}

const header = "border-b border-gray-main py-4 px-6 flex justify-between items-center gap-x-2";

const overlay = "fixed top-0 left-0 right-0 bottom-0 z-20 bg-black/70";

const Styles = {
  modal: modal,
  wrapper: wrapper,
  header: header,
  overlay: overlay
};

function make(isShown) {
  return function (onCloseOpt) {
    const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
          
        });
    return function (title) {
      return function (className) {
        return function (children) {
          return function (wrapperClassName) {
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                className: overlay,
                                onClick: (function (param) {
                                    Curry._1(onClose, undefined);
                                  })
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                children: "" + title
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx(CloseSvg, {}),
                                                onClick: (function (param) {
                                                    Curry._1(onClose, undefined);
                                                  })
                                              })
                                        ],
                                        className: header
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: children
                                      })
                                ],
                                className: Cn.fromList({
                                      hd: wrapper(isShown),
                                      tl: {
                                        hd: Cn.take(wrapperClassName),
                                        tl: /* [] */0
                                      }
                                    })
                              })
                        ],
                        className: Cn.fromList({
                              hd: modal(isShown),
                              tl: {
                                hd: Cn.take(className),
                                tl: /* [] */0
                              }
                            })
                      });
          };
        };
      };
    };
  };
}

function Modal(Props) {
  return Curry._4(make(Props.isShown)(Props.onClose), Props.title, Props.className, Props.children, Props.wrapperClassName);
}

const make$1 = Modal;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
